import { Link, useNavigate } from 'react-router-dom';
import { AppFrame, StatusBanner } from '../components/ui';
import { GuideCharacter } from '../reactions/GuideCharacter';
import { useAppStore } from '../store/AppStore';

const apiMode = import.meta.env.VITE_API_MODE ?? 'mock';

export function PublicEntryScreen() {
  const navigate = useNavigate();
  const { setRole, loading } = useAppStore();

  const enter = async (role: 'child' | 'parent') => {
    if (apiMode === 'mock') {
      await setRole(role);
      navigate(role === 'child' ? '/child/home' : '/parent/home');
      return;
    }
    navigate(`/login?role=${role}`);
  };

  return <AppFrame screenClass="public-entry-screen-2-8">
    <StatusBanner />
    <section className="public-entry-hero-2-8">
      <div className="public-entry-copy-2-8">
        <span>MY REAL MONEY · RELEASE 2.13</span>
        <h1>오늘의 한 걸음부터<br/><strong>즐거운 금융 성장</strong></h1>
        <p>스노스와 선택하고, 기록하고, 가족과 함께 성장해요.</p>
      </div>
      <GuideCharacter guide="snows" pose="guide" state="guide" alt="MRM 시작을 안내하는 스노스" priority />
    </section>

    <section className="public-entry-actions-2-8" aria-label="MRM 시작 방법">
      <button className="entry-role-card primary" type="button" data-reaction="mission.start" disabled={loading} onClick={() => void enter('child')}>
        <span><small>아이 경험</small><strong>아이와 시작하기</strong><em>한 가지 행동부터 바로 시작해요</em></span><b>›</b>
      </button>
      <button className="entry-role-card" type="button" data-reaction="choice.selected" disabled={loading} onClick={() => void enter('parent')}>
        <span><small>부모 경험</small><strong>부모로 시작하기</strong><em>지금 확인할 일과 성장 이야기를 봐요</em></span><b>›</b>
      </button>
      <Link className="entry-role-card" to="/demo" data-reaction="world.opened">
        <span><small>서비스 체험</small><strong>MRM 체험하기</strong><em>아이·부모·기관 관점에서 살펴봐요</em></span><b>›</b>
      </Link>
    </section>

    <footer className="public-entry-footer-2-8">
      <Link to="/login">운영 로그인</Link><span>·</span><Link to="/01">처음부터 온보딩</Link><span>·</span><Link to="/demo">서비스 체험</Link>
    </footer>
  </AppFrame>;
}

type QaGroup = { title: string; description: string; items: { label: string; to: string }[] };

const qaGroups: QaGroup[] = [
  { title:'시작·계정', description:'가입과 진단 흐름', items:[
    {label:'스플래시',to:'/01'},{label:'부모 회원가입',to:'/02'},{label:'자녀 프로필',to:'/03'},{label:'돈 습관 진단',to:'/04'},{label:'진단 결과',to:'/05'},{label:'목표 스노우볼',to:'/06'}
  ]},
  { title:'아이 경험', description:'오늘·월드·성장·가족', items:[
    {label:'아이 홈',to:'/child/home'},{label:'용돈 기록',to:'/child/records'},{label:'오늘의 미션',to:'/child/missions'},{label:'월드 허브',to:'/child/world'},{label:'첫 7일',to:'/child/first-week'},{label:'주간 성장',to:'/child/weekly-expedition'},{label:'금융 패스포트',to:'/child/passport'},{label:'명예의 전당',to:'/child/hall-of-honor'}
  ]},
  { title:'부모 경험', description:'확인·성장·가족·설정', items:[
    {label:'부모 홈',to:'/parent/home'},{label:'미션 승인',to:'/parent/approvals'},{label:'패스포트 확인',to:'/parent/passport'},{label:'주간 인사이트',to:'/parent/weekly-insight'},{label:'가족 탐험대',to:'/parent/family-expedition'},{label:'응원 메시지',to:'/parent/family-talk'},{label:'보상 설정',to:'/parent/rewards'},{label:'자녀 PIN',to:'/security/pin'}
  ]},
  { title:'데모·운영', description:'사용자 화면과 분리된 도구', items:[
    {label:'목적별 데모',to:'/demo'},{label:'아이 체험',to:'/demo/child'},{label:'부모 체험',to:'/demo/parent'},{label:'금융 패스포트 데모',to:'/demo/passport'},{label:'기존 통합 런처',to:'/operations'},{label:'관리자 콘솔',to:'/admin'}
  ]}
];

export function QaSitemapScreen() {
  return <AppFrame title="운영자 사이트맵" backTo="/" screenClass="qa-sitemap-screen-2-8">
    <section className="qa-sitemap-intro-2-8">
      <span>QA · PRESENTATION · OPERATIONS</span>
      <h2>사용자 홈과 분리된<br/>전체 화면 바로가기</h2>
      <p>발표·검수·운영에 필요한 화면만 모았습니다. 일반 아이·부모 메뉴에는 노출되지 않습니다.</p>
    </section>
    <div className="qa-sitemap-groups-2-8">{qaGroups.map((group) => <section key={group.title} className="qa-sitemap-group-2-8">
      <header><div><small>{group.description}</small><h3>{group.title}</h3></div><b>{group.items.length}</b></header>
      <div>{group.items.map((item, index) => <Link key={item.to} to={item.to}><span>{String(index+1).padStart(2,'0')}</span><strong>{item.label}</strong><b>›</b></Link>)}</div>
    </section>)}</div>
  </AppFrame>;
}
